export default {
  status: {
    airport: 'Airport',
    aircraft: 'Aircraft',
    rc: 'Remote Controller',
    airportCount: 'Airport: {count}',
    aircraftCount: 'Aircraft: {count}',
    rcCount: 'RC: {count}',
  },
  time: {
    month: 'mo',
    day: 'd',
    hour: 'h',
    minute: 'm',
    second: 's',
  },
  osd: {
    airport: 'Airport',
    aircraft: 'Aircraft',
    signalStrength: 'Signal strength',
    rcBattery: 'RC battery level',
    droneBattery: 'Drone battery level',
    rtkFixed: 'RTK fixed',
    gps: 'GPS',
    rtk: 'RTK',
    flightMode: 'Flight mode',
    asl: 'Altitude (ASL)',
    alt: 'Altitude (AGL)',
    altFromAirport: 'Height above airport takeoff point',
    homeDistance: 'Distance to home',
    horizontalSpeed: 'Horizontal speed',
    verticalSpeed: 'Vertical speed',
    windSpeed: 'Wind speed',
    accRuntime: 'Total runtime',
    activationTime: 'Activation time',
    networkStatus: 'Network status',
    jobCount: 'Total airport job count',
    mediaRemainUpload: 'Remaining media uploads',
    airportStorage: 'Airport storage: {used} / {total}',
    rainfall: 'Rainfall',
    envTemperature: 'Ambient temperature',
    airportTemperature: 'Airport temperature',
    airportHumidity: 'Airport humidity',
    workingVoltage: 'Working voltage',
    workingCurrent: 'Working current',
    droneInDock: 'Drone in dock',
    uploadSignal: 'Upload signal',
    downloadSignal: 'Download signal',
    droneBatteryDock: 'Drone battery level',
    aircraftStorage: 'Aircraft storage: {used} / {total}',
    operate: 'Operate',
    rainfallLevel: {
      0: 'No rain',
      1: 'Light rain',
      2: 'Moderate rain',
      3: 'Heavy rain',
    },
  },
}
